"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4.525 6.04c-.587 0-1.075.482-1.075 1.093v5.734c0 .61.488 1.093 1.075 1.093h6.387c.588 0 1.075-.483 1.075-1.093v-1.963a.24.24 0 0 1 0-.012V9.108a.24.24 0 0 1 0-.012V7.133c0-.61-.487-1.093-1.075-1.093H4.526Zm8.962 1.486v-.393a2.584 2.584 0 0 0-2.575-2.593H4.526A2.584 2.584 0 0 0 1.95 7.133v5.734a2.584 2.584 0 0 0 2.575 2.593h6.387a2.584 2.584 0 0 0 2.575-2.593v-.393l1.855 1.508c1.099.893 2.708.091 2.708-1.3V7.317c0-1.39-1.609-2.193-2.707-1.3 0 .001 0 0 0 0l-1.855 1.509Zm0 1.932v1.083l2.802 2.277a.162.162 0 0 0 .261-.136V7.317a.161.161 0 0 0-.261-.135l-2.802 2.276Z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=VideoIcon20.js.map